import { ChevronUp, ChevronDown } from 'lucide-react';
import { TableHead } from '@/components/ui/table';

type SortColumn = 'startTime' | 'name' | 'status' | 'duration';
type SortDirection = 'asc' | 'desc';

interface SortableTableHeadProps {
  column: SortColumn;
  children: React.ReactNode;
  sortBy: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
  className?: string;
}

export const SortableTableHead = ({
  column,
  children,
  sortBy,
  sortDirection,
  onSort,
  className = '',
}: SortableTableHeadProps) => {
  const isActive = sortBy === column;

  return (
    <TableHead
      className={`cursor-pointer hover:bg-accent/50 select-none ${className}`}
      onClick={() => onSort(column)}
    >
      <div className="flex items-center justify-between">
        <span>{children}</span>
        <div className="ml-2 flex flex-col">
          {isActive && sortDirection === 'asc' && <ChevronUp className="h-4 w-4 text-foreground" />}
          {isActive && sortDirection === 'desc' && (
            <ChevronDown className="h-4 w-4 text-foreground" />
          )}
          {!isActive && (
            <div className="h-4 w-4 opacity-0 group-hover:opacity-30">
              <ChevronUp className="h-4 w-4" />
            </div>
          )}
        </div>
      </div>
    </TableHead>
  );
};
